/* Copyright 2015 Adrian Bortun adi@use4.ro */
/* global SS, nf, edit_surface, Q, session, dn, template, tabular_data, interface_on_save, TE, EP, clf_btn, fnz_btn, exception_flag, BAC, save_btn, user_btn, undo_btn, redo_btn, edit_btn, COLECTED_FKID_HINTS, mantain_server_session, MAIN, Promise */
// SAVE // UNDO REDO

//(function () {
// !!! BAC >>>  structura HTML  OBLIGATORIE  ["#edit_btn", "#save_btn", "#undo_btn", "#redo_btn"]

var task_btn = Q("#task_btn"),
    nav_btn = Q("#nav_btn"),
    tools_btn = Q("#tools_btn"),
    edit_buttons = Q("[editable_state_buttons]")[0],
    cascade_undo_wiping = null,
    SED; // session.edited_data to be stored here

Object.defineProperty(window, "session", {
    // protecting session definition
    value: function () { },
    configurable: true,
});

function* uniqueIdGenerator() {
    let id = 1; // Start at 1 (or any desired starting value)
    while (true) {
        yield id++;
    }
}

// Usage:
const generateId = uniqueIdGenerator();


//  ESC, CTRL, SHIFT, (ALT/OPTION)->ALT   (WIN/CMD)->META
(function enable_shortcuts() {
    window.addEventListener("keydown", function (ev) {
        // incerc sa modific aspectul unor interfete 523
        if (!ev.repeat) {
            // key hold sets event.repeat true so I want listen only first occurence
            switch (ev.key) {
                case "Shift": // 16
                    session.shift = true;
                    document.documentElement.setAttribute("shift", true);
                    break;
                case "Control": // 17
                    session.ctrl = true;
                    document.documentElement.setAttribute("ctrl", true);
                    break;
                case "Alt": // 18
                    ev.preventDefault();
                    session.alt = true;
                    document.documentElement.setAttribute("alt", true);
                    break;
                case "Meta": // 91
                    ev.preventDefault();
                    session.meta = true;
                    document.documentElement.setAttribute("meta", true);
                    break;
            }
        }
    });
    window.addEventListener(
        "keyup",
        function (e) {
            switch (e.key) {
                case "Shift":
                    delete session.shift;
                    document.documentElement.removeAttribute("shift");
                    break;
                case "Control":
                    delete session.ctrl;
                    document.documentElement.removeAttribute("ctrl");
                    break;
                case "Alt":
                    delete session.alt;
                    document.documentElement.removeAttribute("alt");
                    break;
                case "Meta":
                    delete session.meta;
                    document.documentElement.removeAttribute("meta");
                    break;
            }
        },
        false
    );
})();


// EDITING  PROPERTIES
Object.defineProperties(session, {
    toString: {
        value: function () {
            return "[object session]";
        },
    },
    store: {
        value: ["edited_data", "stack", "tmp"],
        enumerable: false,
        configurable: true,
    }, // volatile  --  se salveaza la onBeforeUnload
    //['project', 'editing','action'] NEVOLATILE
    check: {
        value: function () {
            // se trimite si un header('code') care reface multe proprietati din session ---  ex session.pers_id='32';
            var chain = new Chain();
            ask(
                "users\\session",
                { fresh: 1 },
                function (email) {
                    session.domain_user = email || null;
                    session.updated = Date.now();
                    session.modules = JSON.parse(session.modules || "{}") || {}; //  tre sa schimb comportamentul in funcie de modulele activate pt site-ul curent
                    chain.resolve(session);
                    window.fire("session_updated");
                },
                function (r) {
                    // conexiune pierduta
                    session.domain_user = null; // si am date ne salvate ce fac????
                    //dn(r,"STATUS",1000);
                },
                { loader: "circle" }
            );
            return chain;
        },
    },
    check_local_concurent_editing: {
        value: function () {
            broadcast.push("check_local_concurent_editing", history.now);
        },
    },
    check_remote_concurent_editing: {
        // TODO: --- use wss !!!BAC>>>
        value: () => {
            return;
            wss_socket
                .push({
                    users: ["#check_concurent_editing"],
                    data: history.now,
                })
                .then(Q.i); // a promise
        },
    },
    enter_edit_mode: {
        value: async function enter_edit_mode() {
            if (session.outdated) {
                edit_switch.active = false;
                edit_btn.show_error(
                    "<h5 style='margin:1em 0'>OUTDATED INTERFACE</h5><hr/>PLEASE RELOAD!"
                );
                return;
            }

            // trebuie sa impiedic editarea concurentiala pe acelasi context (p_id,ref_tb,ref_id,...)  
            session.check_local_concurent_editing();
            session.check_remote_concurent_editing();

            //global TE === edit_surface.first.template --- templatului instantiat in zona editabila  #MAIN

            // asignare tip flat_copy nu referinta pt a avea datele in caz ca renunta la modificari 
            session.edited_data = session.edited_data || JSON.parse(JSON.stringify(TE.data));


            if (!session.changes) { // map2  // !!!BAC>>> vezi input_assist.js > remap_inputs  -- 
                TE.inputs_to_remap.map(e => {
                    let path = e.data_path  // in input_assist 
                    path && session.edited_data.pointer(path, e.value);
                })
            }

            session.stack = session.stack || [null]; // page reload  kepps stack 
            session.in_out = true;
            session.tmp = session.tmp || {};
            session.cursor = session.cursor || 0; // de aici refac butoanele de undo redo la reload de pagina
            session.changes = session.changes || false;


            edit_surface.on("change", session.modify_edited_data);
            window.on("keydown", session.listen_shortcuts, true);

            edit_surface.editable = 1; // de aici scot disabled de pe textarea,input, etc daca nu au attribut readoly

            sessionStorage.save_id = session.changes
                ? sessionStorage.save_id
                : "u" + session.user_id + session.__sbd__ + "_t" + Date.now(); /// pers_id !!!! ca sa fie unic


            TE.enter_edit_mode && TE.enter_edit_mode();

            if (TE.catalog) {
                // !!!BAC>>> p_id asistat in forme pt folosirea arc_name --- fake input numit catalog ca sa nu dea conflict cu arc_name folosit de ex in requests
                // ATENTIE nu am voie sa folosesc mai mult de o forma cu catalog enabled ca iese o ameteala ---  sau rescriu chestia cu asistarea  p_id in forme 
                session.tmp.catalog = TE.catalog.value
            }
            generated_dids = {};

        },
    },

    generate_did: {
        value: function () {
            return "did" + Date.now() + generateId.next().value;
        }
    },
    exit_edit_mode: {
        value: async function (silent) {
            if (!silent && session.changes && !confirm("DOCUMENT HAS CHANGES ! \n\n ***  DISCARD  ***   ?")) {
                // asta ramine aici ca merge cu prevenirea navigarii la date nesalvate
                edit_switch.active = true; // !!!BAC???
                return 0;
            }

            if (TE.memorize && TE.uncomited_stack) {  // MEMORIZE
                if (!session.changes) {
                    var N = Math.abs(session.cursor - TE.uncomited_stack.length);
                    while (N) {
                        session.redo();
                        await wait(1)
                        --N;
                    }
                }
                else {
                    session.changes = false;
                    template(history.now.tail({ into: MAIN, clear: 1 })).then(() => {
                        setTimeout(() => {
                            // edit_btn.show_error("<h5>MEMORIZED-DATA RESTORED</h5>", 3000)
                        }, 1000);
                    });
                    edit_surface.editable = 0; // disble pe toate inputurile
                    return;
                }

            } else {
                if (session.changes) {// undo everithing
                    var CR = session.cursor;
                    var XFS = edit_surface.find("x-form[top]");
                    XFS.map(xf => xf.pagination_enabled && (xf.wait = 1)); // previn repaginarea multipla
                    try {
                        while (CR--) session.undo();
                    } catch (err) {
                        console.log(err);
                    }
                    setTimeout(() => {
                        XFS.map(xf => xf.pagination_enabled && (xf.wait = 0)); // rpaginare daca e cazul
                    }, 50);
                }
                edit_surface.first.fire("discard");
                session.stack = [null];
                session.cursor = 0;
                session.tmp = {};
                if (!history.now.memorize) {
                    // trebuie sa am datele din session.editing_data permanent pt ca fac calcule pe VALORI VIRTUALE
                    session.edited_data = null;
                }
                session.changes = false;
            }

            edit_surface.off("change", session.modify_edited_data);
            window.off("keydown", session.listen_shortcuts, true);

            edit_surface.editable = 0; // disble pe toate inputurile

            delete SS.COLECTED_FKID_HINTS; // !!! BAC >>> sterg backup-ul pt hinturi care se face la beforeunload daca am session.changes
            delete SS.store;
            delete SS.MAP2_DICTIONARY;
            Q.AST.awake = false;
            TE.exit_edit_mode && TE.exit_edit_mode(session.exiting_after_save);
            delete session.exiting_after_save;
            sessionStorage.removeItem("save_id");



            edit_switch.dom.removeAttribute("edit_switch_active");
            edit_switch.action(false);
            edit_switch._active_ = false;


            return 1;
        },
    },
    editing: {
        get: () => {
            return TE ? { name: TE.name, project: TE.project, request: TE.request, action: TE.action, } : null;
        }
    },
    undo_all: {
        // undo everithing including session.edited_data modification
        value: function () {
            //console.log("undo_all");
            if (session.changes) {
                session.burst_undo_redo = true;
                var CR = session.cursor;
                try {
                    while (CR--) session.undo();
                } catch (err) {
                    console.log(err);
                }
                setTimeout(function () {
                    session.burst_undo_redo = false;
                }, 100);
            }
        },
    },

    // SHORTCUTS for UNDO REDO EXIT SAVE
    listen_shortcuts: {
        value: function (ev) {



            const isSave =
                (ev.ctrlKey || ev.metaKey) &&
                !ev.shiftKey &&
                ev.key.toLowerCase() === 's';

            if (isSave) {
                ev.preventDefault();
                ev.stopPropagation();

                Q("#save_btn").click();
                return;
            }

            const isUndo =
                (ev.ctrlKey || ev.metaKey) &&
                !ev.shiftKey &&
                ev.key.toLowerCase() === 'z';

            const isRedo =
                ((ev.ctrlKey || ev.metaKey) && !ev.shiftKey && ev.key.toLowerCase() === 'y') ||
                (ev.metaKey && ev.shiftKey && ev.key.toLowerCase() === 'z'); // Mac

            if (edit_switch.active) {
                if (Blinder.active) {

                    if (isUndo) Blinder.undo();
                    if (isRedo) Blinder.redo();

                } else {

                    if (isUndo) {
                        ev.preventDefault();
                        session.undo();
                    }

                    if (isRedo) {
                        ev.preventDefault();
                        session.redo();
                    }

                    const isQuit =
                        (ev.ctrlKey || ev.metaKey) &&
                        !ev.shiftKey &&
                        ev.key.toLowerCase() === 'd';

                    if (isQuit) {
                        ev.preventDefault();
                        edit_switch.dom.click();
                    }
                }
            }
        },
    },




    validate_error_message: {
        value: "",
        writable: true,
    },
    validate: {
        value: function (tb_name, cdf, tg, _ov) {
            switch (true) {
                case cdf.type === "date" && tg.value.trim() !== "":
                    var parts = tg.value.match(/(\d+)/g);
                    if (parts && parts[2] && parts[2].length === 4) { // 12/4/2024  
                        tg.value = parts[2] + "-" + twoDigits(parts[1]) + "-" + twoDigits(parts[0]);
                    } else if (parts) {
                        tg.value = parts[0] + "-" + twoDigits(parts[1]) + "-" + twoDigits(parts[2]);
                    }
                    var ok_date = new Date(tg.value).date === tg.value;
                    if (parseInt(tg.value) > 9999) {
                        ok_date = false;
                    }
                    if (!ok_date || !parts || parts.length !== 3) {
                        Q.validate_error_message = `<h5>${tg.value}</h5>`;
                        return 0;
                    }
                    break;
                case cdf.type == "datetime" && tg.value.trim() !== "":
                    ok_date = true;
                    let d = /(\d{4}-\d+-\d+)\s?(.*)/.exec(tg.value);
                    switch (true) {
                        case parseInt(tg.value) > 9999:// mariadb limit 10000
                        case !d: // nu am structura year-month-day .* 
                        case !d[1]:
                            ok_date = false;
                            break;

                        case d[1]: // date segment
                            let date_ok = session.validate(null, { type: "date" }, { value: d[1] });
                            if (!date_ok) {
                                ok_date = false;
                            }
                            break;
                        case d[2]: // time segment
                            let time = d[2].split(":");
                            if (!(time.length === 3
                                && parseInt(time[0], 10) >= 0
                                && parseInt(time[0], 10) <= 23
                                && parseInt(time[1], 10) >= 0
                                && parseInt(time[1], 10) <= 59
                                && parseInt(time[2], 10) >= 0
                                && parseInt(time[2], 10) <= 59)) {
                                ok_date = false;
                            }
                            break;

                    }

                    if (!ok_date) {
                        Q.validate_error_message = `<h5>${tg.value}</h5>`;
                        return 0;
                    }

                    break;
                case cdf.type.indexOf("decimal") > -1 && tg.value.trim() !== "":
                    var V = tg.value.trim();
                    if (/[^\d\.,-]/.test(V)) {
                        Q.validate_error_message =
                            "DECIMAL REQUIRED<br/>ex: 123.00";
                        return 0;
                    }
                    tg.value = Q.float0(tg.value);
                    break;
                case cdf.type.indexOf("int(") > -1 && !cdf.cmt.map2 && (tg.value + '').trim() !== "":
                    if (parseInt(tg.value) !== +tg.value) {
                        Q.validate_error_message = "INTEGER REQUIRED";
                        return 0;
                    }
                    break;
                case tg.hasA("list"):
                    if (!tg.options.has(tg.value)) {
                        tg.value = "";
                        return 0;
                    }
                    break;
                case tg.hasA("validate"): // tg.cdf.validate : "special format or rule"
                    {
                        var validator_name = tg.getA("validate") || tg.name;
                        var validator = Q.validators[validator_name];
                        if (validator && validator(tg.value)) {
                            //tg.value = _ov;
                            return 0;
                        }
                    }
                    break;
            }
            return 1;
        },
    },

    record: { // inregistreaza editarile in session.stack
        value: async function (obj, cascade) {
            if (!obj.id) {
                console.log("PROBLEMA CU SEGMENT FARA id !!!!!", obj);
                return;
            }
            session.changes = true;
            var ss = session.stack.slice(0, session.cursor + 1);
            var stack_segment = obj.flat_copy(); // decuplare de referinta pt ca unele obiecte din stack au proprietati care se modifica in timp 
            if (cascade) {
                ss.last().cascade_redo = 1;
                stack_segment.cascade_undo = 1;
            }
            ss.push(stack_segment);
            session.stack = ss;
            session.cursor++;
            if (obj.act === "d") {
                await check_fkid_delete_restricted_record(obj, session.cursor); // face undo daca este cazul 
            }
            return stack_segment;
        },
    },



    // !!!BAC>>> ATENTIE
    //--- INSERT si DELETE se fac de pe elementele capabile (tabular_data,x-form,flike,comp,hr_chart etc ... )
    //  modificarea  session.edited_data pt insert si delete este in responsabilitatea  obiectelor smart    [x-doc]
    // inclusiv bind-column-values 

    modify_edited_data: {
        // UPDATE ONLY  --- la change pe orice input trebuie sa updatez session.stack si session.edited_data ++session.cursor
        value: function (ev) {
            var tg = ev.target;

            // !!!BAC>>> de studiat  
            // daca e text !!! merge trim altfel 
            //tg.value = tg.value.trim(); // elimin blank-uri care pot pacali inputuri not null  -- asta face o gramada de chestii 
            //typeof tg.value === 'string' && (tg.value = tg.value.trim());

            var X = tg.closest("[xdoc]");
            if (!X) return; // ignor tot ce nu e sub XDOC
            var tb_name = tg.tb_name ?? X.getA("xdoc").trim(),
                SED = session.edited_data; // acum e referinta // !!!BAC>>> ar trebui facuta flat_copy ca sa rup refenta  

            // chestie particulara la x-file sa pot forta o alta tabela !!!
            if (tg.tagName === "X-FILE" && tg.force_table) {
                tb_name = tg.force_table;
            }
            // ignor modificari in ceva ce nu afecteaza mysql
            if (!SED[tb_name] || !TE.tdf[tb_name].hasOwnProperty(tg.name)) {
                if (X.tagName != "X-GRID-EDITOR" || X.tagName != "X-DOSSIER") {
                    return;
                }
            }

            var parent = tg.parent,
                path = [],
                ord = TE.columns[tb_name].indexOf(tg.name),
                id, pagination;
            // am nevoie de un path cu care sa modific edited_data [tb_name,set_index,column_index,parent_rid]
            switch (X.tagName) {
                case "X-FORM":
                    var t = X.xform_edited_input_path(tg),
                        path = t.path,
                        id = t.id,
                        parent_rid = t.parent_rid;
                    var top_xform = tg.closest("x-form[top][level='0']")
                    if (top_xform && top_xform.pagination_enabled) {
                        pagination = {
                            id: top_xform.id,
                            page: top_xform.current_page
                        }
                    }
                    break;
                case "X-GRID":
                case "X-GRID-EDITOR":
                case "X-DOSSIER":
                    var t = X.edited_input_path(tg),
                        path = t.path,
                        id = t.id
                    break;
                case "TABLE":
                    if (0) {
                        path = X.oo.path_to_td(tg.parent);
                        id = SED[tb_name][path[1]][0]; //  ma uit in session.edited_data   SED.tb_name.row_idx[0]  ---  am totdeauna id pe prima coloana
                    } else {
                        // old style cu inca o cautare pe dom
                        var tabular_obj = X.oo;
                        path = tabular_obj.path_to_td(tg.parent);
                        id = parent.parent.querySelector("td").querySelector("input").value;
                    }
                    break;
                case "FOX":
                    path = [tb_name, tg.rowIndex, ord];
                    id = tg.parent.parent.find("input")[0].value;
                    break;
                case "X-FOX":
                    path = [tb_name, tg.rowIndex, ord];
                    id = tg.parent.parent.getA("rid");
                    break;
                case "FORM":
                    if (X.hasA("comp_parent_name")) {
                        var comp_id = X.getA("comp_parent_id");
                        path = [tb_name, comp_id, 0, ord];
                        id = SED[tb_name][comp_id][0][0];
                    } else {
                        path = [tb_name, 0, ord];
                        id = SED[tb_name][0][0];
                    }
                    break;
                case "COMP":
                    path = [
                        tb_name,
                        X.comp_id,
                        tg.parent.parent.rowIndex,
                        tg.parent.colIndex,
                    ];
                    id = tg.parent.parent.find("input")[0].value;
                    break;
                default: // FLIKE
                    var sbj = X.getA("subject"),
                        pfkid = X.getA("pfkid"),
                        z_data = SED[tb_name][sbj][pfkid];
                    var ridx = z_data.find_set(X.getA("rid"), 0, 1);
                    path = [tb_name, sbj, pfkid, ridx, ord];
                    id = z_data[ridx][0];
                    break;
            }

            /* REJECT CHANGE */
            {
                var _ov = session.edited_data.pointer(path); // ORIGINAL VALUE  --- before editing value
                //  trebuie sa tratez echivalenta dintre null  si '' empty string 
                if (_ov === null) {  // acelasi comportament cu input.value=null  >>> input.value === ''
                    _ov = '';
                }

                // Lister -- daca nu am valoare din lista oferita (editare in input) refuz modificarea
                if (tg.change_only_by_assist && ev.isTrusted) {
                    tg.value = _ov;
                    return;
                }

                // nu inregistrez blancuri la final de cimp si nici daca valoarea memeorata in session.edited_data este aceasi cu tg.value
                if ((_ov + "").trim() === (tg.value + "").trim() && !ev.force_update) return;

                if (tg.cdf.cmt.require) {
                    let LR = tg.closest("[logical_row]"), require = tg.cdf.cmt.require;
                    if (!Array.isArray(require)) {
                        require = [require];
                    }
                    for (let i in require) {
                        let c_name = require[i], inp = LR.find(`[name=${c_name}]`, 1);
                        if (inp) {
                            if (!Q.is_db_value(inp.value)) {
                                tg.value = _ov || "";
                                inp.show_error("REQUIERED FIRST");
                                inp.focus();
                                return;
                            }
                        }
                        else {
                            console.log("ERROR >>> " + tg.tb_name + "." + tg.name, "REQUIRE: ", tg.cdf.cmt.require, `LOGICAL_SIBLING ${c_name} NOT FOUND`)
                        }

                    }

                }
                // VALIDARE
                if (session.validate(tb_name, TE.tdf[tb_name][tg.name], tg, _ov) !== 1) {
                    tg.shup({
                        info:
                            "<div nowrap style='margin-bottom:1em;'><small><sad style='position: relative;top:.1em;left:-.1em' c></sad></small> <b>INVALID ENTRY</b></div>" +
                            (Q.validate_error_message
                                ? "<div k style='margin:.5em 0'>" +
                                Q.validate_error_message +
                                "</div>"
                                : ""),
                        time: 3000,
                    });
                    Q.validate_error_message = "";
                    tg.value = _ov || "";
                    tg.scroll2view().tmpA("spark").focus();
                    return;
                }
            }


            //  EDITED_DATA UPDATE
            session.edited_data.pointer(path, tg.value);   // !!!BAC>>> session este salvat in SS cu  window.beforeunload si refacut la Document.ready

            // STACK RECORD
            var obj = {
                act: "u",
                path: path,
                c_name: tg.name,
                from: _ov || "",
                to: tg.value,
                id: id,
                real_value: Q.db_value(tg.real_value),
                old_real_value: Q.db_value(tg.old_real_value)
            };


            if (X.hasA("comp_parent_name")) {
                obj.m_form = X.getA("comp_parent_name");
            } else if (X.tagName === "X-FORM") {
                obj["xform"] = 1;
                obj.parent_rid = parent_rid;
                if (pagination !== undefined) {
                    obj.pagination = pagination;
                }
            }
            else if (X.tagName === "X-GRID") {
                obj.gid = t.gid;
                obj.inst = t.inst;
                obj.x_grid = 1;
            }
            else if (X.tagName === "X-GRID-EDITOR") {
                obj[X.tagName.toLowerCase()] = 1;
                obj.resolver = X.constructor.name;
            }
            else {
                obj[X.tagName.toLowerCase()] = 1;
            }


            // if (ev.calculation) {
            //     session.stack.last() && (session.stack.last().cascade_redo = 1);
            //     obj.cascade_undo = 1;
            // }


            session.record(obj); // scriu in  session.stack  



            session.update_generated_values({
                field: tg,
                data_path: [...path],
                row_id: +id
            });

            //  vin cu  elm.fire("change",{cascade:1 })  ;  si session intelege ca ultimul stack segment este cascadat la cel anterior 
            if (ev.cascade && session.stack.length > 2) {
                let o = session.stack;
                o[o.length - 1].cascade_undo = 1;
                o[o.length - 2].cascade_redo = 1;
            }

            // anunt ca s-a updatat session.edited_data
            tg.fire("change_written");

            // RESETAREA DEPENDENTILOR   // !!!BAC>>> only siblings 
            let resets = tg.cdf.cmt.resets || tg.resets || null;
            if (resets && !session.resets_off) {  // works with logical_siblings
                if (resets == "*") {
                    var A = [...TE.columns[tg.tb_name]];
                    A.remove(tg.name, "id", "ref_id");
                    resets = tg.cdf.cmt.resets = A;
                }
                if (/^\^/.test(resets)) { // reset all but  cmt = {"resets","^[\"col_1\",\"col_2\"]"}
                    var B = resets.replace("^", "").parsed, A = [...TE.columns[tg.tb_name]];
                    A.remove(tg.name, "id", "ref_id", ...B);
                    resets = tg.cdf.cmt.resets = A;
                }
                resets.map(c_name => {
                    let elm = tg.logical_sibling(c_name);
                    if (elm) {  // !! daca am ascuns un camp dintr-o forma si nu am elementul //  numai elementele afishate ---  deci atentie ce scriu in ref_col.cmt
                        elm.value = ''; // same as null 
                        if (elm.real_value) {
                            elm.old_real_value = elm.real_value; // pt undo/redo
                        }
                        delete elm.real_value;
                        elm.tmpA("reseted");
                        elm.fire("change", { cascade: 1, resetor: tg });
                    }
                });
                // !!!BAC>>> daca am si setare de valoare a unui element resetat trebuie sa folosesc setTimeout(()(=>{ an_element.value = 123; }))
            }
        }
    },

    undo: {
        value: function (wipe_last) {
            if (TE.before_undo && TE.before_undo()) {
                return;
            }
            if (session.cursor === 0) return;
            var field = session.reflect_stack_position("from");
            if (
                (typeof wipe_last !== "object" && wipe_last) ||
                cascade_undo_wiping
            ) {
                var slice = session.stack.pop();
                cascade_undo_wiping = !!slice.cascade_undo;
                if (session.stack.length === 1) {
                    // am sters cascadat pina la inceputul editarii deci nu mai am changes
                    session.changes = false;
                }
            }
            session.cursor--;
            (field || edit_surface.first).fire("undo", { field: field });
            TE.after_undo && TE.after_undo();
        },
    },
    redo: {
        value: function () {
            if (TE.before_redo && TE.before_redo()) {
                return;
            }
            if (session.cursor === session.stack.length - 1) return;
            session.cursor++;
            var field = session.reflect_stack_position("to");
            // console.log(field);
            (field || edit_surface.first).fire("redo", { field: field });
            TE.after_redo && TE.after_redo();
        },
    },

    reflect_stack_position: {
        value: function (sense, is_redo_uncommited_changes) {
            var c = session.cursor,
                stk = session.stack,
                path = stk[c].path,
                val = stk[c][sense], // aici stabilesc setul de date
                act = stk[c].act,
                zone,
                name,
                fliked_elm,
                field,
                SED = session.edited_data;
            if (stk[c].resolver) {
                // daca editarea se face cu un smart_obiect suport ex hr_chart care nu se incadreaza in MAIN.multiform atunci
                // TE.hr_chart trebuie sa existe in scopul global si sa aiba metoda    reflect_stack_position

                switch (true) {
                    case act === "u":
                        session.edited_data.pointer(path, val); // modify record in column ord
                        break;
                    case (act === "d" && sense === "from") ||
                        (act === "i" && sense === "to"): // reinsert record
                        session.edited_data[path[0]].splice(path[1], 0, val);
                        break;
                    default: // delete re_delete
                        session.edited_data[path[0]].splice(path[1], 1);
                        break;
                }
                (TE[stk[c].resolver] || window[stk[c].resolver]).reflect_stack_position(stk[c], sense);
            } else {
                switch (true) {
                    case act === "u": {
                        // update a field

                        switch (1) {
                            case stk[c].flike:
                                zone = edit_surface.find("[xdoc = " + path[0].esc_css_selector + "][rid = '" + (stk[c].id + "") + "']", 1);
                                name = zone.oo.columns[path[4]];
                                field = zone.find("[name='" + name + "']", 1);
                                break;
                            case stk[c].comp:
                                zone = edit_surface.find("[xdoc ~=" + path[0] + "][comp_id ~='" + path[1] + "']", 1);
                                field = zone
                                    .find("[comp_table]")[0]
                                    .children[path[2]].children[path[3]].find("input,textarea,select", 1);
                                break;
                            case stk[c].table:
                                zone = edit_surface.find("[xdoc ~=" + path[0].esc_css_selector + "]", 1);
                                name = TE.columns[path[0]][path[2]];
                                //field = zone.find("tbody", 1).find("tr")[path[1]].children[path[2]].find("[name='" + name + "']", 1); // !!!BAC>>> da in bot pt KVL si orice table as insera in div-ul de hint
                                field = zone.tbody.rows[path[1]].cells[path[2]].find("[name='" + name + "']", 1);
                                break;
                            case stk[c].fox:
                                zone = edit_surface.find("[xdoc ~=" + path[0].esc_css_selector + "]", 1);
                                field = zone.find("[fox_cell ='" + path[1] + "_" + path[2] + "']", 1);
                                break;
                            case stk[c].form:
                                zone = edit_surface.find("form[xdoc ~=" + path[0].esc_css_selector + "]", 1);
                                name = TE.columns[zone.getA("xdoc").trim()][path[2]];
                                field = zone[name] || zone.find("[name=" + name + "]", 1); // support for x-check elements
                                break;
                            case stk[c]["xform"]:
                                try {
                                    if (stk[c].pagination !== undefined) {
                                        var
                                            P = stk[c].pagination,
                                            xform = edit_surface.find("#" + P.id, 1);
                                        if (xform.current_page !== P.page) {
                                            xform.goto_page(P.page);
                                        }
                                    }

                                    zone =
                                        edit_surface.find("[xdoc='" + path[0] + "'][parent_rid='" + stk[c].parent_rid + "'] > [x-form-panel] > [rid='" + stk[c].id + "']", 1) || // nested  x-form
                                        edit_surface.find("[xdoc='" + path[0] + "'][parent_rid='" + stk[c].parent_rid + "'] > [x-form-panel] table [rid='" + stk[c].id + "']", 1) || // nested compact x-form
                                        edit_surface.find("[xdoc='" + path[0] + "'] > [x-form-panel] > [rid='" + stk[c].id + "']", 1) || // top x-form
                                        edit_surface.find("[xdoc='" + path[0] + "'][top] > [x-form-panel] table [rid='" + stk[c].id + "']", 1) // top x-form compact
                                        ;

                                    name = TE.columns[path[0]][path[2]];

                                    field = zone.find("[name=" + name + "]", 1);
                                } catch (e) {
                                    //console.log(e, stk[c], c);
                                }
                                break;
                            case stk[c].x_grid:
                                zone = edit_surface.find('x-grid[xdoc="grid_a"][gid="' + stk[c].gid + '"]', 1);
                                field = zone.reflect_stack_position(stk[c], sense);
                                break;
                            case stk[c]["x-tree"]:

                                // !!!BAC>>> folosesc mecanismul cu resolver
                                // zone = edit_surface.find('[xdoc="' + path[0] + '"][row_id = "' + stk[c].id + '"]', 1);
                                // console.log(zone);;
                                // field = zone.reflect_stack_position(stk[c], sense);

                                break;
                            case stk[c]["x-fox"]:
                                try {
                                    zone = edit_surface.querySelector('x-fox[xdoc="' + path[0] + '"] tr[rid="' + stk[c].id + '"]', 1);
                                    name = TE.columns[path[0]][path[2]];
                                    field = zone.find("[name=" + name + "]", 1);
                                } catch (e) {
                                    console.log(e, stk[c], c);
                                }
                                break;
                            case stk[c].m_form.length > 0 ? 1 : 0:
                                zone = edit_surface.find("[xdoc ~='" + stk[c].m_form + "'] [xdoc='" + path[0].esc_css_selector + "'][comp_parent_id='" + path[1] + "']", 1);
                                name = TE.columns[path[0]][path[3]];
                                field = zone[name] || zone.find("[name=" + name + "]", 1);
                                break;
                        }

                        if (field) {
                            field.scroll2view(); //  un-collapse the DOM tree above 
                            try {
                                field.auto_resize_height();
                            } catch (err) { }
                            field.tmpA("spark", 500);
                            field.value = val;
                            if (sense === "from") {
                                field.real_value = stk[c].old_real_value; // BAC??? nu e bine cu real value
                            } else {
                                field.real_value = stk[c].real_value;
                            }
                            session.edited_data.pointer(path, val);

                            session.update_generated_values({
                                field: field,
                                data_path: [...path],
                                row_id: +stk[c].id
                            });
                        }
                        break;
                    }

                    case (act === "d" && sense === "from") ||
                        (act === "i" && sense === "to"): { // REINSERT ELEMENT
                            if (stk[c].flike) {
                                SED[path[0]][path[1]][path[2]].splice(path[3], 0, val);
                                var css_query = "[tpln][subject ='" + path[1] + "']" + (path[2] ? "[pfkid='" + path[2] + "']" : "");
                                fliked_elm = edit_surface.find(css_query, 1);
                                var flike = fliked_elm.fliker.add_flike(val, stk[c].row).children[1].tmpA("spark").scroll2view();
                                is_redo_uncommited_changes && flike.setA("memorized_field");
                            } else if (stk[c].comp) {
                                SED[path[0]][path[1]] = val;
                                var comp_elm = edit_surface.find("[tpln =" + path[0].replace(/_/, "/") + "]", 1);
                                comp_elm.comp_data.add_component(val, path[2]).scroll2view();
                            }



                            else if (stk[c].xform) {
                                // REINSERT XROW in X_FORM

                                // daca am paginare trebuie sa ma duc la pagina unde era xrow-ul inainte de reinsert
                                var page, top_xform;
                                if (stk[c].page !== undefined) {
                                    top_xform = edit_surface.find("#" + stk[c].xform + "[top]", 1);
                                    if (top_xform.pagination_enabled && top_xform.current_page !== stk[c].page) {
                                        // e nevoie  sa navigez la pagina in care urmeaza sa fac xrow reinsert
                                        page = stk[c].page
                                        top_xform.total_pages = Math.max(top_xform.total_pages, page + 1); // ?
                                        top_xform.goto_page(page, { action: "select_edited_page" });
                                    }
                                }

                                var xform =
                                    edit_surface.find("#" + stk[c].xform + " [tb_name='" + stk[c].path[0] + "'][parent_rid='" + stk[c].path[1] + "']", 1)
                                    ||
                                    edit_surface.find("#" + stk[c].xform, 1);

                                var row = xform.ins_row(stk[c]); // adapteaza si session.edited_data 

                                // daca am facut reinsert in top_xform este posibil sa am prea multe xrows pe pagina curenta 
                                if (top_xform == xform && top_xform.pagination_enabled) {
                                    var row_idx = row.rowIndex;
                                    top_xform.goto_page(stk[c].page, { action: "add_row" });
                                    //  fortez adaptarea la paginare in caz ca numarul de xrows a depasit numarul maxim pe pagina dupa reinsert
                                    //  ca sa fie destept ar trebui doar sa verifice daca numarul de xrows a depasit numarul maxim pe pagina dupa reinsert si doar atunci sa forteze adaptarea la paginare
                                    //  si de fapt ar trebui sa elimine last xrow si sa dea comanda de  update_pagination_infoca sa nu mai chinui domul 
                                    row = top_xform.rows[row_idx];
                                    // setTimeout(() => {
                                    row.scroll2view().tmpA("spark");
                                    // }, 0);
                                }

                                if (is_redo_uncommited_changes) {
                                    row.setA("memorized_row")
                                }

                                var xrow = xform.parent;
                                xrow && xrow.hasA("collapsed") && xrow.onoff.click();


                            } else {
                                // table
                                SED[path[0]].splice(path[1], 0, val);
                                var zone = edit_surface.find("[xdoc ~=" + path[0].esc_css_selector + "]", 1);
                                zone.oo.ins_row(val, path[1], { spark: 1 }).scroll2view(); //.scrollIntoViewIfNeeded();
                            }
                            break;
                        }

                    default: {// === REMOVE ELEMENT ===
                        if (stk[c].flike) { //delete flike
                            SED[path[0]][path[1]][path[2]].splice(path[3], 1);
                            var flike = edit_surface.find("[subject ='" + path[1] + "'][pfkid='" + path[2] + "'][rid='" + stk[c].id + "']", 1);
                            flike.scroll2view();
                            flike.die(0.1);
                            --flike.oo.elm.num_flike;
                        } else if (stk[c].comp) {
                            delete SED[path[0]][path[1]];
                            var comp = edit_surface.find("[xdoc ~=" + path[0] + "][comp_id ~='" + path[1] + "']", 1);
                            comp.scroll2view();
                            comp.die(0.1);
                        } else if (stk[c].xform) {
                            // X_FORM DELETE

                            // STEP 1: Navigate to page FIRST (before removing from SED or DOM)
                            var top_xform;
                            if (stk[c].page !== undefined) {
                                top_xform = edit_surface.find("#" + stk[c].xform + "[top]", 1);
                                if (top_xform && top_xform.pagination_enabled) {
                                    if (top_xform.current_page !== stk[c].page) {
                                        // Navigate to the page where the ancestor row is
                                        top_xform.goto_page(stk[c].page, { action: "select_edited_page" });

                                    }
                                }
                            }

                            // STEP 2: Remove from SED
                            SED[path[0]].splice(stk[c].row, 1);

                            // STEP 3: Find and remove the xrow from DOM (no meter the level of nesting)
                            var xrow =
                                edit_surface.find("#" + stk[c].xform + " [tb_name ~='" + path[0] + "'] [rid~='" + stk[c].id + "']", 1) ||
                                edit_surface.find("#" + stk[c].xform + " [rid~='" + stk[c].id + "']", 1);
                            if (xrow) {
                                var siblings = xrow.siblings();
                                xrow.scroll2view();
                                xrow.tmpA("spark");
                                setTimeout(() => {
                                    xrow.die(0.2);
                                    if (top_xform && top_xform.pagination_enabled && top_xform == xrow.xform) {
                                        if (siblings.length === 0 && top_xform.current_page > 0) {
                                            top_xform.current_page--;
                                        }
                                        setTimeout(() => {
                                            top_xform.goto_page(top_xform.current_page, { action: "rem_row" });
                                        }, 200);
                                    }
                                }, 0);
                            }
                        } else {
                            //delete row in tabular table
                            try {
                                SED[path[0]].splice(path[1], 1);
                                var zone = edit_surface.find("[xdoc ~=" + path[0].esc_css_selector + "]", 1);
                                zone.scroll2view();
                                zone.querySelector("tbody")
                                    .children[path[1]].tmpA("spark")
                                    .die();
                            } catch (e) {
                                console.log(e, "DE REZOLVAT PROBLEME CU EDITUL");
                            }
                        }
                    }
                }
            }

            // CASCADED UNDO/REDO
            if (sense === "from" && stk[c].cascade_undo && edit_switch.active) {
                // tre sa previn asta pt REDO UNCOMITED CHANGES
                setTimeout(function () {
                    session.undo();
                }, 0);
            } else if (sense === "to" && stk[c].cascade_redo && edit_switch.active) {
                //setTimeout(function () {
                session.redo();
                // }, 0);
            } else {
                session.no_animation = false;
            }
            return field;
        },
    },

    save: {
        value: async function () {  // !!!BAC>>> cred ca se poate simplifica mult --- asa intuiesc
            // verifica diferitele relatii intre campuri si face o verificare finala a corectitudinii valorilor pt update
            if ((TE.logic_check || nf)()) {
                return;
            }
            var sql_do = [];
            //  retin doar pina la cursor  fara sa modific stack ca la sPlice (slice in place)
            var o = JSON.stringify(session.stack.slice(1, session.cursor + 1)).parsed;  // e flat_copy  deci nu afecteaza stack-ul in caz de save fail 
            // MEMORIZE
            if (history.now.memorize && !history.now.commit) {
                this.memorize_changes(o);
            } else {
                // SAVE or COMMIT
                sql_do = session.prepare_sql_do(o); // filtrare actiuni inutile ---- grupare actiuni pe mysql
                if (Q.validate(MAIN, sql_do)) {
                    return;
                }
                if (TE.before_save) {
                    // BEFORE_SAVE --- varificari si adaptari finale specifice componentei js a interfetei care salveaza
                    var stop_save_reason = await TE.before_save(sql_do);
                    if (stop_save_reason) {
                        typeof stop_save_reason === "string" && dn(stop_save_reason, "SAVE HALT");
                        return;
                    }
                }

                if (sql_do.length === 0 && !TE.force_save) {
                    // nu am nimic in sql_do si nici nu vreau sa fortez template.save ca sa ajung in RZV
                    on_save_done(0);
                } else {
                    save_btn.tmpA("disalbled"); // no dblclick
                    if (TE.force_rzv_only) {
                        if (!TE.hasOwnProperty("post")) {
                            TE.post = {};
                        }
                        TE.post.tail({ sql_do }); // interface.rzv o sa stie ce stack de editare e in client
                        sql_do = [];
                    }

                    if (TE.preg_sql_do) { // EX?
                        var O = TE.preg_sql_do, STR = JSON.stringify(sql_do);
                        for (let p in O) {
                            STR = STR.replace(new RegExp(p, "gm"), O[p]);
                        }
                        sql_do = STR.parsed;
                    }

                    // !!!BAC>>>   TE.final_confirm trebuie sa fie ori o functie care intoarce  true/false ori un promise care se rezolva candva true/false
                    return Promise.all([TE.final_confirm ? TE.final_confirm() : true]).then(
                        (r) =>
                            r[0] && ask(
                                "template.save",
                                {
                                    stack: sql_do, // processed editing stack 
                                    save_id: sessionStorage.save_id /* PREVIN SAVE MULTIPLU */,
                                    test_insert: TE.conf.test_insert.length ? TE.conf.test_insert : "",
                                    ...history.now, // trebuie sa vad compatibilitatea  ,
                                    project: TE.project,
                                    action: TE.action,
                                    request: TE.request,
                                    interface: TE.name,
                                    PUI: TE.PUI,
                                    route: TE.route,
                                    ...TE.post,
                                    //  }.tail(TE.composed), // ???? nu am tot in history  -- !!! preg-uri 
                                },
                                function (rez, code, xhr) {
                                    on_save_done(rez, code, xhr);
                                },
                                function (r) {
                                    dn(
                                        "<table><tr><td style='padding:1em;vertical-align:top;'><sad></sad></td><td style='font-family:Thin;color:white;padding:1em'> " +
                                        r +
                                        "</td></tr></table>",
                                        "SAVE FAIL"
                                    );
                                }
                            )
                    );
                }
            }
        },
    },

    rzv: {
        value: async function (data, cb = nf) {
            // ast asigura si TRANSACTION PROTECTION
            var rzv_response;
            await ask(
                "template.save",
                {
                    data,
                    save_id: sessionStorage.save_id,
                    ...history.now.crop_keys(["project", "action", "interface", "ref_id"]),
                },
                function (rsp, code, xhr) {
                    rzv_response = xhr.header("rzv_echo"); // !!!BAC>>>  ca sa nu amestec cu template:save response folosesc header("rzv_echo:".json_encode($out)); in interface.rzv
                }
            );
            cb(rzv_response);
            return rzv_response;
        },
    },
    memorize_changes: {
        value: async function (o) {
            if (Q.validate(MAIN)) {
                return;
            }
            zero_data = null;
            if (TE.zero_data_required) { // la insertul in memorized_changes.sql
                zero_data = {};
                TE.data.scan((k, v) => {
                    if (!["req_dcz", "req_obs", "req_clf", "requests"].has(k)) {
                        zero_data[k] = [];
                        if (Array.isArray(v)) {
                            zero_data[k] = [];
                            v.map(a => {
                                zero_data[k].push([].combine(TE.columns[k], a))
                            });
                        }
                        else {
                            zero_data[k] = {};
                            for (let sbj in v) {
                                zero_data[k][sbj] = v[sbj] // de studiat ceva recursiv pt flike-uri si componente 
                            }
                        }
                    }
                });
            }
            var post = { stack: o, client_ip: session.client_ip };
            if (zero_data) {
                post.zero_data = zero_data; // datele initiale ale interfetei (numai memorize-editing zone)
            }
            post.tail(
                history.now.crop_keys([
                    "project",
                    "action",
                    "ref_tb",
                    "ref_id",
                    "src",
                    "interface",
                    "repair"
                ])
            );

            // la decizia pozitiva a managerului fac template-save 
            var o = JSON.stringify(session.stack.slice(1, session.cursor + 1)).parsed;  // e 
            var sql_do = session.prepare_sql_do(o);
            if (TE.before_save) {
                // BEFORE_SAVE --- varificari si adaptari finale specifice componentei js a interfetei care salveaza
                var stop_save_reason = await TE.before_save(sql_do);
                if (stop_save_reason) {
                    typeof stop_save_reason === "string" && dn(stop_save_reason);
                    return;
                }
            }
            post.sql_do = sql_do;


            return ask("template.memorize_changes", post, function (r) {
                dn("MEMORIZED", "---", 700);
                TE.uncomited_stack = [...o];
                o.unshift(null);
                session.stack = o; //  aici se eleimina redo la care s-a renuntat
                TE.data = session.edited_data.flat_copy();
                session.changes = 0;
                edit_switch.active = false;
            });
        },
    },
    prepare_sql_do: {
        value: function (o) {
            TE.data_adjust && TE.data_adjust(o); // before anithing on save 

            // formare sql_do
            var sql_do = [];
            SED = session.edited_data.flat_copy(); // !!! BAC >>> important de folosit  COPIE DE OBIECT -- ca sa pot edita in caz de fail la save -- daca nu fac copie alterez session.edited_data prin referentiere  

            // M_FORM eliminarea recordurilor m_form pt care am si delete al componentei parinte
            var indexes_to_remove = [];
            for (var v in o) {
                if (o[v].act === "d" && o[v].comp) {
                    // trebuie sa sterg orice update sau insert al m_form
                    for (var i in o) {
                        if (
                            o[i].m_form === o[v].path[0] &&
                            o[i].path[1] === o[v].id
                        ) {
                            indexes_to_remove.push(i);
                        }
                    }
                }
            }
            o.drop(indexes_to_remove);



            /*** COMPRESSED_UPDATES  */
            /// !!!BAC>>>  // destruct update_many in multiple updates for compatibility with field_update --
            // editare in Blinder are ca rezultat un stk_sgm in care from=[,,,] to = [,,,]  adica array // exeplu activitati_amend_cc
            // undo-redo sunt speciale pt ca trebuie distribuite
            var X = [];
            o.map((s) => {
                if (s.act === "u" && Array.isArray(s.to)) {   // deci numai pt update  ca am to = [,,,] la insert dar e altceva 
                    var tb_name = s.path[0];
                    TE.columns[tb_name].map((c_name, idx) => {
                        if (s.from[idx] !== s.to[idx]) {
                            var p = {
                                act: "u",
                                id: s.id,
                                path: [...s.path],
                                row: s.row,
                                update_flatened: 1,
                                c_name,
                            };
                            p.path.push(idx);
                            p.to = s.to[idx];
                            p.from = s.from[idx];
                            X.push(p);
                        }
                    });
                } else {
                    X.push(s);
                }
            });
            o = X;





            // DELETE FLIKE DESCENDENTS
            // corectie stack pt ca la delete on flike sa sterg orice descendant de tip flike
            for (var v in o) {
                if (o[v].act === "d" && o[v].flike) {
                    var rec_sbj = o[v].path[1],
                        id = o[v].id;
                    for (var tb in SED) {
                        if (gettype(SED[tb] === "Object")) {
                            var sbjo = SED[tb];
                            for (var sbj in sbjo) {
                                if (sbj.indexOf(rec_sbj) === 0 && rec_sbj !== sbj) {
                                    for (var pfkid in sbjo[sbj]) {
                                        var sets_arr = sbjo[sbj][pfkid];
                                        sets_arr.map(function (set, row) {
                                            var R = {};
                                            R.act = "d";
                                            R.path = [tb, sbj, pfkid, row];
                                            R.from = set;
                                            R.to = null;
                                            R.id = set[0];
                                            R.row = row;
                                            R.flike = sbj;
                                            SED[tb][sbj][pfkid].splice(row, 1); // sterg flike-uri orfane din session.edited_data
                                            o.push(R);
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }

            var transformed_m_forms = [];

            for (var v in o) {
                var table = o[v]["path"][0],
                    id = o[v]["id"];
                switch (o[v]["act"]) {
                    case "d":
                        sql_do.map(function (i, idx) {
                            // sterg inregistrarile de update-uri sau insert  a ceea ce urmeaza sa fie sters  -- inclusiv stk_sgm current ca fac push adaptat mai jos un pic
                            // x-form orphaned descendents  --- resolved  at bottom of this function
                            if (i.table === table && i.id == id) {
                                sql_do.splice(idx, 1);
                            }
                        });

                        if (!/^did/.test(id)) {
                            //  inregistrez stergerea din server pt table.id   --  daca e cu did se cupleaza insert cu delete si nu se mai trimite nimic la server
                            var obj = {
                                table: table,
                                id: id,
                                act: "d",
                                from: o[v].from,
                            };
                            if (o[v].flike) {
                                obj.ref = [TE.ffp, o[v].path[2], o[v].path[1],];
                            }
                            if (o[v].comp) {
                                obj.comp = 1;
                            }

                            // x-form sterge din definitia  foreign_key   on delete cascade  adica toti descendentii de la orice nivel dispar 


                            /* 
                            --- MERGING RECORDS ---   
                            do_before_delete: {  // 
                                method: "id_chelt_merge",  php_class_or_method
                                args: {
                                    to_id_chelt: data_TO.id,
                                    from_id_chelt: data_FROM.id
                                }
                            } 
                            
                            --- ex un punct bugetar nu poate fi sters daca are cheltuieli pe el ci poate fi merged la un altul apoi sters ---
                            */
                            if (o[v].do_before_delete) {
                                obj.do_before_delete = o[v].do_before_delete; // semnal catre server sa trateze special segmentul de stack inainte de stergere
                            }
                            sql_do.push(obj);
                        }
                        break;
                    case "i":
                        // inregistrez operatiunea de insert
                        var obj = {
                            table: table,
                            id: id,
                            act: "i",
                            vals: o[v]["to"],
                        };
                        var tdf = TE.tdf[obj.table];
                        var idx = 0; // DEFAULT VALUES -- ex CURRENT_TIMESTAMP BAC!!!
                        for (var p in tdf) {
                            if (tdf[p].dft && tdf[p].req && !o[v].to[idx]) {
                                //console.log(idx, table, o[v], tdf[p].dft);
                                obj.vals[idx] = tdf[p].dft;
                            }
                            ++idx;
                        }
                        if (o[v].flike) {
                            obj.ref = [TE.ffp, o[v].path[2], o[v].path[1]];
                            obj.reuse = o[v].reuse;
                            obj.flike = 1;
                        }
                        if (o[v].comp) {
                            obj.comp = 1;
                        }
                        if (o[v].xform) {
                            obj.xform = 1;
                        }
                        if (o[v].obs) {
                            obj.obs = o[v].obs;
                        }
                        sql_do.push(obj);
                        break;

                    case "u":  // updaturile asigura map2
                        if (Q.is_db_value(o[v].real_value)) { // ca sa accepte si "0" sau 0   --- null, undefined, '' are not accepted as real value  
                            // rezolvarea imputurilor mapate
                            o[v].to = +o[v].real_value || o[v].real_value;
                        }
                        if (Q.is_db_value(o[v].old_real_value)) { // ca sa accepte si "0" sau 0   --- null, undefined, '' are not accepted as real value  
                            // rezolvarea imputurilor mapate
                            o[v].from = +o[v].old_real_value || o[v].old_real_value;
                        }
                        //  de_alias(o[v]); // BUG: rupe x-form !!!!!! habar n-am de ce?

                        if (/^did/.test(o[v]["id"])) {
                            if (o[v].m_form && !transformed_m_forms.has(o[v].id)) {// rezolvarea M_FORM -  adaugate  u->i
                                var R = o[v];
                                transformed_m_forms.push(R.id);
                                //transformam update in insert
                                var vals = [].fill_new("", TE.columns[R.path[0]].length);
                                vals[0] = R.id;
                                vals[1] = TE.ffp;
                                vals[2] = R.path[1];
                                vals[R.path[3]] = R.to;
                                var obj = {
                                    table: R.path[0],
                                    id: R.id,
                                    act: "i",
                                    vals: vals,
                                    m_form: R.m_form,
                                };
                                sql_do.push(obj);
                            }
                            else {// gruparea unui insert cu updaturile sale
                                sql_do.map(function (rec, idx) {
                                    if (rec.table === table && rec.id === id) {
                                        if (rec.ref) {
                                            // pt FLIKE
                                            rec.vals[o[v]["path"][4]] = o[v]["to"];
                                        } else if (rec.m_form) {
                                            //  pt M_FORM
                                            rec.vals[o[v]["path"][3]] = o[v]["to"];
                                        } else {
                                            rec.vals[o[v]["path"][2]] = o[v]["to"];
                                        }
                                    } else if (rec.table === table && rec.comp) {
                                        rec.vals[o[v]["path"][2]][o[v]["path"][3]] = o[v]["to"];
                                    }
                                });
                            }
                        }
                        else {
                            // inregistrari existente in server cu gruparea update-urilor pt aceasi pozitie
                            var found_prev_update = false,
                                //idx = o[v]['path'].length === 3 ? 2 : 3,
                                col_name = TE.columns[table][o[v]["path"].last()];

                            // f prost asa ar trebui sa-mi fac un obiect martor in care sa fac insert si daca am insert sa ceva altfel

                            sql_do.map(function (i) {
                                // grupez updaturile pt aceasi linie
                                if (i.table === table && i.id === id && i.hasOwnProperty("set")) {
                                    if (i["set"][col_name]) {
                                        i["set"][col_name][0] = o[v]["to"];
                                    } else {
                                        i["set"][col_name] = [o[v]["to"], o[v]["from"]];
                                    }
                                    if (o[v].obs) {
                                        i.obs = o[v].obs;
                                    }
                                    found_prev_update = true;
                                    return;
                                }
                            });
                            if (!found_prev_update) {
                                // e 1st update pe linie
                                var obj = {
                                    table: table,
                                    id: id,
                                    act: "u",
                                    set: {}
                                };
                                if (o[v].obs) {
                                    obj.obs = o[v].obs;
                                }
                                obj.set[col_name] = [o[v]["to"], o[v]["from"]];
                                sql_do.push(obj);
                            }
                        }
                        break;
                }
            }

            // CLEANINIG AND ADAPTING
            for (var v in sql_do) {
                var R = sql_do[v];
                if (!R.id) {
                    // inregistrarea din stack nu are id trec de la update to insert --  ??? UNDE E SITUATIA ASTA ???
                    R.act = "i";
                    R.vals = [];
                    TE.columns[R.table].map(function (i, idx) {
                        R.vals[idx] = R.set[i] || "";
                    });
                    R.vals[1] = session.editing.project;
                    delete R.set;
                }

                if (R.act === "i") {
                    // R.vals = [...R.vals];
                    //delete R.id;
                    if (R.comp) {
                        R.vals.map(function (set) {
                            set[0] = null;
                        });
                    } else {
                        R.vals[0] = ""; // am intotdeauna id ca prima coloana si fac "INSERT INTO tb_name VALUES(null,....)"
                        // BAC !!!!!!!!!!!!!!!!!!!!!!!!!!!!! --- ATENTIE ---------
                        // CALCULATED_COLUMNS -- nu am voie sa fac insert in db pt anumite coloane
                        // trimit la server TE.gnr={tb_name:{col1:0,...col_gnr:1}, }  obiect cu toate coloanele tabelei   si TE.qfs = {tb_name:{col1_qfs:1,col2:1}}
                    }
                }

                // elimin recorduri pt care valoarea dupa multiple editari este egala cu originalul
                if (R.act === "u") {
                    // row cu updaturi multiple grupate in stk_sgm.set object
                    for (var col_name in R.set) {  // !!!BAC>>> DE VERIFICAT daca folosesc FLIKE si M_FORM
                        if (R.set[col_name][0] == R.set[col_name][1]) {
                            delete R.set[col_name];
                        }
                    }

                    if (R.set.pkeys().length === 0) {
                        sql_do.drop(v);
                    }
                }
            }


            // FLAT FORM     transform update in insert for id not numeric 
            for (var v in sql_do) {
                var R = sql_do[v]; // R = record
                if (R.id && typeof R.id === "string" && R.id.indexOf("__") === 0) { // __tb_name__ + Date.now() 
                    R.act = "i";
                    var cols = TE.columns[R.table],
                        P = [].fill_new(null, cols.length);

                    P = SED[R.table][0]; // SED este [...session.edited_data]

                    //P[0] = null; // NU NU NU //!!!BAC>>> ca nu mai stie on_save_done sa inlocuiasca  id-ul dynamic 
                    // --- am pus in template.save pt act==='i' vals[0]=null adica id === null

                    for (var v in R.set) {
                        P[cols.indexOf(v)] = R.set[v][0];
                    }
                    delete R.set;
                    R.vals = P;

                    // rezolve default values and binded values
                    var OB = TE.conf.rules[R.table] && TE.conf.rules[R.table].bind ? TE.conf.rules[R.table].bind : null;
                    TE.columns[R.table].map(function (col, idx) {
                        // put default values 
                        if (R.vals[idx] === null) {
                            R.vals[idx] = TE.tdf[R.table][col].dft;
                        }
                        // binding 
                        if (col === "p_id" && TE.ffp) {
                            R.vals[idx] = TE.ffp; //"__new__"; // !!!BAC>>> ??? pentru inregistrare proiect 
                        } else {
                            if (OB && OB.hasOwnProperty(col)) {
                                if (gettype(OB[col]) === "Object") {  // reference-bind   rules:{ this_table:{ this_col :{ another_table: another_column } }}
                                    var tb_name = OB[col].pkeys()[0],
                                        c_name = OB[col][tb_name] || "id";
                                    R.vals[idx] = SED[tb_name][0][TE.col_idx(tb_name, c_name)];
                                } else {
                                    R.vals[idx] = OB[col]; // preg-bind  {ref_id : __ref_id__ }   ; pseudo-constants  pe care le calculeaza serverul la template::compose
                                }
                            }
                        }
                    });
                }
            }


            /********
              CALCULATED_STACK  --- absolete --- am renuntat 
             ***************/




            // REUSE FLIKE 
            for (var v in sql_do) {
                if (sql_do[v].reuse) {
                    sql_do[v].act = "r";
                }
            }


            /**********************************************
                ORPHANED INSERTS & HIDDEN REQUIRED FIELDS 
            ***********************************************/

            let out = [], DIDS = {};
            sql_do.map(S => {
                if (S.act === "i") {
                    DIDS[S.id] = 1; var ins = true;
                    for (let i in S.vals) {
                        if (i > 0 && /^did/.test(S.vals[i])) { // daca am prins un camp cu referinta  la ceva ce urmeaza a fi inserat 
                            if (!DIDS[S.vals[i]]) { // si nu exista un parinte care sa genereze id -- pt ca a fost sters
                                delete (DIDS[S.id]); // toti descendentii vor fi ignorati la insert 
                                ins = false; // segmentul de stack current este eliminat 
                                break;
                            }
                        }
                    }
                    if (ins && S.xform == 1) {
                        // insert pe x-form level N cu required field necompletat urmat de stergere ancestor (level N - x)
                        // Q.validate nu reactioneaza pt ca nu mai am campul in DOM dar template::save va da error
                        var row = edit_surface.find(`x-row[rid=${S.id}]`, 1);
                        if (!row) { // un ancestor a fost sters deci nu mai am elementul in DOM  --- 
                            delete (DIDS[S.id]);
                            ins = false;
                        }
                    }
                    ins && out.push(S) //|| console.log("SKIP",S);
                }
                else {
                    out.push(S);
                }
            });
            return out;

        }
    },
    drop_changes: {
        value: function () {
            session.undo_all();
            session.stack = [null];
            session.edited_data = TE.data.flat_copy(); // ?? atentie ar trebui verificat daca sunt in stare edit
            session.cursor = 0;
            session.changes = false;
        },
    },
    redo_uncomited_changes: {
        value: function (DATA = null) { // pentru task-uri co zone de editare memorize ca sa nu afectez session edited data cu stack-ul zonelor editate dar sa afishez modificarile
            //  console.trace(__ML__);
            if (DATA) {
                var STACK0 = session.stack, SED0 = session.edited_data, SCUR0 = session.cursor;
            }
            session.edited_data = TE.data.flat_copy(); // copiez datele di template si reaplic modificarile

            if (DATA) {
                var stk = session.stack = DATA;
                // console.log("**** PARTIAL redo_uncomited_changes")
            }
            else {
                var stk = session.stack = (TE.uncomited_stack || []).flat_copy();
                //console.log("DEFAULT redo_uncomited_changes")
            }

            if (!Array.isArray(stk)) {
                session.stack = stk = []
            }
            stk.unshift(null); // am rafacut stack-ul de editare 

            session.cursor = 0;
            var N = session.stack.length;
            var ch = new Chain();
            (async function redo_step() {
                if (--N > 0) { // fara null de la inceputul stack-ului
                    ++session.cursor;
                    try {
                        var rec = stk[session.cursor],
                            delay = 0;
                        if (rec.flike && rec.act === "i") {
                            var p = rec.path;
                            !session.get("edited_data." + p[0] + "." + p[1] + "." + p[2]) &&
                                session.set("edited_data." + p[0] + "." + p[1] + "." + p[2], []);
                            delay = 500; // trebuie sa apuce sa refaca flike-ul
                        }
                        if (rec.m_form && rec.act === "u") {
                            // probleme cu m_form incluse in componenta adaugata in memorize
                            console.log(
                                rec,
                                "probleme cu m_form",
                                rec.path
                            );
                        }
                        var field = session.reflect_stack_position("to", true);
                        field && field.setA("memorized_field").setA("disabled");

                        setTimeout(function () {
                            redo_step();
                        }, delay);
                    } catch (e) {
                        console.log(session.cursor, rec, e);
                        redo_step();
                    }
                } else {

                    // am ajuns la finalul redo-ului adica am refacut toate modificarile necomise si pot sa activez butonul de commit daca e cazul
                    // dau semnale ca s-a terminat redo-ul 

                    var changes_to_commit = session.stack.length - 1;
                    dn.delay(300)(`<h2 lc>${changes_to_commit}</h2>`, "MEMORIZED CHANGES", 4000);
                    if (history.now.commit) {
                        TE.rendered[0].setA("changes_to_commit", changes_to_commit);
                    }
                    edit_surface.first.fire("memoriezed_data_restored");
                    // console.log("memoriezed_data_restored", DATA ? "--PARTIAL--" : "--NORMAL--")
                    if (DATA) {
                        session.stack = STACK0
                        session.edited_data = SED0;
                        session.cursor = SCUR0;
                    }

                    ch.resolve();
                }
            })();
            return ch;
        },
    },

    // GENERATED_COLUMNS
    update_generated_values: {
        value: function (B) {// { field:'<textarea>/<input>', data_path:[tb_name,[sbj_id],row_idx,ord], row_id: stk[c].id }
            let A = TE.table_has_gnr(B.data_path[0]);  // lista de coloane generate sau false
            if (A.length) {
                let tb_name = B.data_path[0],
                    row = B.field.closest("[logical_row]"),
                    tdf = TE.tdf[tb_name];
                B.data_path.pop();// fac asa pt flike si components pt au structura cu subject id .... [4 segments in path] 

                let RD = session.edited_data.pointer(B.data_path), // reference
                    D = [].combine(TE.columns[tb_name], RD);
                A.map(c_name => {
                    var gnr = tdf[c_name].gnr, value, inp;
                    inp = row.find("[name=" + c_name + "]", 1);
                    if (gnr.indexOf("concat") >= 0) {
                        // text
                        gnr = gnr.replace(/`\w*?`/gim, function (x) {
                            var c_name = x.replace(/`/gim, "");
                            return "`" + (D[c_name] || "") + "`";
                        });
                        value = eval("String." + gnr);
                    } else {
                        // numbers
                        gnr = gnr.replace(/`\w*?`/gims, function (x) {
                            var c_name = x.replace(/`/gims, "");
                            return D[c_name] || 0;
                        });

                        if (/if\(/.test(gnr)) { // 100 * if(0 + 480000.00,ifnull(291200.00,0) / 480000.00,NULL)  --- nasol cu procentele 
                            gnr = gnr.replace(/if\(.*\)/, function (x) {
                                let A = x.split(","),
                                    cond = A.shift().replace("if(", ''),
                                    not_rez = A.pop().replace(")", ''),
                                    poz_rez = A.join(',');
                                if (/^.*100/.test(gnr)) {
                                    not_rez = parseInt(not_rez) || 0;
                                }
                                return eval(cond) ? poz_rez : not_rez
                            })
                        }
                        gnr = gnr.replace(/ifnull\(/, '').replace(/,.*?\)/, ''); // ifnull(123.00,0) + ifnull(30.33,0) -> 123.00 + 30.33
                        value = eval(gnr);
                        var decimals = TE.decimals[tb_name][c_name];
                        if (decimals) {
                            value = value.locale(decimals);
                        }
                    }
                    inp.value = value;
                    inp.auto_resize_height();
                    RD[tdf[c_name].ord] = value; // reflectare in SED 
                });

            }
        }
    }
});

session.clear_edits = function () {
    if (session.edited_data) {
        session.undo_all();
        session.cursor = 0;
        session.stack = [null];
        redo_btn.setA("disabled");
        undo_btn.setA("disabled");
    } else {

        //console.log("CLEAR_EDITS - nothing in edited_data")
    }
    session.changes = false;
}


// lucru cu sessionStorage -- varibile nevolatile
Object.defineProperties(session, {
    get: {
        value: function (path) {
            path = typeof path === "string" ? path.split(".") : path;
            if (!SS[path[0]]) return undefined;
            var o = SS[path[0]].parsed;
            path.shift();
            for (var i = 0; i < path.length; i++) {
                o = o[path[i]];
                if (!o) return undefined;
            }
            return o;
        },
    },
    set: {
        value: function (path, value) {
            // session.write(_name_, o);
            if (path === undefined) {
                throw new Error(
                    '"session.set" ----  missing path argument ---'
                );
                return;
            }
            path = typeof path === "string" ? path.split(".") : path;
            var _ssb_ = path.shift();
            if (path.length) {
                var o = (SS[_ssb_] || "{}").parsed; // daca e scalar trebuie suprascris cu obiect gol
                var a = o;
                path.forEach(function (p_segment, idx) {
                    if (a[p_segment] === undefined) {
                        a[p_segment] = +p_segment ? [] : {};
                    }
                    a = a[p_segment];
                });
                eval(
                    'o["' + path.join('"]["') + '"] = ' + JSON.stringify(value)
                );
                session.write(_ssb_, o);
            } else {
                value !== undefined
                    ? session.write(_ssb_, value)
                    : SS.removeItem(_ssb_);
            }
        },
    },
    write: {
        value: function (name, o) {
            SS.setItem(name, JSON.stringify(o));
        },
    },
    read: {
        value: function (name) {
            return JSON.parse(SS.getItem(name));
        },
    },
    delete: {
        value: function (name) {
            SS.removeItem(name);
            delete session[name];
        },
    },
    define: {
        // ??  atentie fara initializare ca se fute tot
        value: function (name) {
            Object.defineProperty(session, name, {
                get: function () {
                    return session.read(name);
                },
                set: function (o) {
                    session.write(name, o);
                },
                enumerable: true,
            });
        },
    },
    __sbd__: {
        get: function () {
            var L = location.host.split(".");
            return L.length === 3 ? L[0] : null;
        },
        enumerable: true,
    },
});

["project",/*  "_editing", */ "action"].map(function (name) {
    session.define(name);
});
Object.defineProperty(session, "changes", {
    get: function () {
        return Q.bool(SS.changes);
    },
    set: function (s) {
        SS.changes = s;
        if (window.save_btn) { // interfetze fara top buttons
            Q.bool(s) ? save_btn.remA("disabled") : save_btn.setA("disabled");
        }
    },
});
Object.defineProperty(session, "verbose", {
    get: function () {
        return localStorage.verbose;
    },
    set: function (s) {
        Q.bool(s)
            ? (localStorage.verbose = 1)
            : localStorage.removeItem("verbose");
    },
});

Object.defineProperty(session, "cursor", {
    get: function () {
        return +SS["cursor"];
    },
    set: function (SC) {
        SS.cursor = SC;
        if (SC > 0) {
            undo_btn.remA("disabled");
            save_btn.remA("disabled");
        } else {
            undo_btn.setA("disabled");
            save_btn.setA("disabled");
            if (TE.memorize) {
                save_btn.remA("disabled");
            }
        }
        if (SC < session.stack.length - 1) {
            redo_btn.remA("disabled");
        } else {
            redo_btn.setA("disabled");
        }
        if (session.in_out) {
            delete session.in_out;
        } else {
            session.fire_data_change({ source: "session.cursor" });
        }
        if (
            TE.memorize &&
            TE.uncomited_stack &&
            SC === TE.uncomited_stack.length &&
            !session.changes
        ) {
            save_btn.setA("disabled");
        }
    },
});




// SAVE -- MEMORIZE -- COMMIT
try {
    save_btn.on("click", function () {
        let confirm_text = TE.memorize && !TE.commit ? "MAEMORIZE" : "SAVE"
        !this.hasA("disabled") &&
            (session.changes ||
                TE.commit ||
                (TE.memorize &&
                    session.cursor !== TE.uncomited_stack.length)) &&
            confirm(confirm_text + " CHANGES ?") &&
            session.save();
    });
    undo_btn.on("click", session.undo);
    redo_btn.on("click", session.redo);
} catch (err) {

}


Object.defineProperty(session, 'fire_data_change', {
    get: function () {
        if (!window.fire_data_change) {
            try {
                fire_data_change = function (o) {
                    Q.AST.surface.fire("data_change", o);
                }.debounce(100); // !!!BAC>>> ??? o fi bine ??? 
            } catch (error) {
                console.log(error)
            }
        }
        return fire_data_change;
    }
})



function on_save_done(x, y, z) {
    // response, server_sent_command, xml_http_reguest
    if (x === 0) {
        dn("nothing to do!", "SAVE", 1000);
        return;
    }
    TE.after_save instanceof Function && TE.after_save(x, y, z);
    var panel = dn("<h2 style='color:lime'>OK</h2>", "SAVE", 1000);
    panel.mag && panel.mag.die();

    // inlocuire did - id-uri temporare cu cele obtinute de la mysql server
    var dids = x.parsed,
        SED_string = JSON.stringify(SED);
    for (var did in dids) {
        var ID = dids[did];
        SED_string = SED_string.replace(did.rgx, ID); // aplicarea id-urilor optinute in session.edited_data
        // COMP
        var loc = Q("[comp_id ='" + did + "'")[0];
        if (loc) {
            var p = loc.parent;
            p.remA("init");
            p.html = "";
            p.init();
            continue;
        }
        // TABLE
        var loc = Q("[db_id ='" + did + "']")[0];
        if (loc) {
            loc.parent.find("input", 1).value = ID;
            loc.setAttribute("db_id", ID);
            continue;
        }
        // FLIKE
        loc = Q("flike[rid='" + did + "'")[0];
        if (loc) {
            loc.setAttribute("rid", ID);
            loc.find("[rid_show]", 1).html = ID;
            var inp4id = loc.find("[name='id']", 1);
            inp4id && (inp4id.value = ID);
            continue;
        }
        //M_FROM
        loc = Q("[m_form ='" + did + "'")[0];
        if (loc) {
            loc.id.value = ID;
            loc.setAttribute("m_form", ID);
            continue;
        }
        // X-GRID-EDITOR (tree items inserted with a temporary "did..." id)
        var grid_editor = Q("x-grid-editor")[0];
        var it = grid_editor?.items_by_id?.[did];
        if (it) {
            it.data.id = ID; // shared object -- also updates li.data/item.data since populate_item points both at the same v
            it.setAttribute("q_id", ID);
            it.parent.setAttribute("q_id", ID); // the <li> wrapping this <item>
            it.self_label.setAttribute("q_id", ID);
            it.id_tag.html = ID; // <q_id> tag showing the id as visible text
            grid_editor.items_by_id[ID] = it;
            delete grid_editor.items_by_id[did];
            for (var k in grid_editor.items_by_id) { // re-point any already-rendered children of this node
                var d = grid_editor.items_by_id[k].data;
                if (d.r2 === did) { d.r2 = ID; }
            }
            continue;
        }
        //X-FORM
        Q("[dummy='" + did + "']").map(function (elm) {
            elm.setAttribute("dummy", dids[did]);
        });
        Q("[parent_rid='" + did + "']").map(function (elm) {
            elm.setAttribute("parent_rid", dids[did]);
            elm.parent_rid = dids[did];
        });
        Q("[rid='" + did + "']").map(function (elm) {
            elm.setAttribute("rid", dids[did]);
            elm.rid = dids[did];
        });
    }
    TE.data = SED_string.parsed;  // copiere in  TE.data a noilor valor din session.edited_data  -- la reintrarea in EDIT copiez din TE.data in session.edited_data 
    // QFS --- updatare x-file value
    Q("x-file").map((i) => {
        var D = i.data,
            _D_ = [];
        if (D) {
            D.map((fd) => {
                fd.st = "s";
                delete fd.rnm;
                delete fd.old_name;
                if (!fd.del) {
                    _D_.push(fd);
                }
            });
            i.value = JSON.stringify(_D_);
        }
    });

    // refacere referintele pt seturi de date ale  tabular_data tables
    // !!!BAC>>> aiurea
    /*   for (var i in TE.tabular_data_tables) {
          var t = TE.tabular_data_tables;
          var tbld = t[i];
          tbld.data = TE.data[tbld.tb_name];
      } */

    session.in_out = true;
    session.changes = 0;
    session.stack = [null];

    //session.cursor = 0;
    session.exiting_after_save = true;
    session.exit_edit_mode();
    edit_switch.active = 0;

    //chain.resolve(z);
    broadcast.push("check_outdated_interface", history.now);
}

BroadcastChannel.prototype.push = function (type, data = {}) {
    // console.log(`BROADCASTING: ${type}`);
    return this.postMessage(JSON.stringify({ type, data, id: this.id }));
};

const broadcast = new BroadcastChannel(location.host);
broadcast.id = "_tab_" + Date.now();
//console.log(broadcast.id);
broadcast.addEventListener("message", function (ev) {
    try {
        var obj = JSON.parse(ev.data); // {type:string, data:object, id: source_broadcast.id }
        (broadcast.responder[obj.type] || nf).bind(this)(obj.data, obj.id, ev);
        //console.log("RECEIVED_BROADCAST_OBJECT:", obj);
    } catch (err) {
        console.log("RECEIVED_BROADCAST:" + ev.data, err);
    }
});

broadcast.responder = {
    check_local_concurent_editing: function (data, bid) {
        // bid==='broadcaster.id'
        if (broadcast.conflict(data)) {
            if (session.changes) {
                broadcast.push("TAB_EDITING_CONFLICT", {
                    stack: session.stack.length - 1,
                });
            } else {
                edit_switch.active = false;
            }
        }
    },
    TAB_EDITING_CONFLICT: function (data, bid) {
        edit_btn.show_error(
            `<h3 style='white-space:nowrap'>TAB_EDITING_CONFLICT</h3><hr/>There is another tab with <h6 c>[${data.stack}] changes</h6>on same interface`,
            5000
        );
        edit_switch.active = false;
    },
    check_outdated_interface: function (data, bid) {
        if (broadcast.conflict(data)) {
            dn("<h1>OUTDATED INTERFACE", "WARNING");
            session.outdated = true;
        }
    },
};

broadcast.conflict = (data) => {
    for (let k in history.now) {
        if (data[k] && typeof data[k] === "object") {
            if (!history.now[k].alike(data[k])) {
                return false;
            }
        } else {
            if (history.now[k] !== data[k]) {
                return false;
            }
        }
    }
    return true;
};

// STORE EDITED_DATA && unregister tab from LS.tabs
window.addEventListener("beforeunload", function (ev) {
    history.state && SS.pointer("last_history_state", history.state); //  recovery for interface after network crush
    if (session.changes) {
        var O = {};
        session.store.map((var_name) => (O[var_name] = session[var_name]));
        SS.store = JSON.stringify(O);
        SS.COLECTED_FKID_HINTS = JSON.stringify(COLECTED_FKID_HINTS);
        SS.MAP2_DICTIONARY = JSON.stringify(MAP2_DICTIONARY);
    }
    LS.pointer(["tab_list", broadcast.id], false); // remove tab from LS.tab_list
    // Explicitly shut down the broadcast port
    broadcast.close();
});

// recover some session properties from localstorage after reload
if (SS.store) {
    var O = SS.store.parsed;
    session.store.map((name) => (session[name] = O[name]));
}



// EDIT_SWITCH
edit_switch = { dom: window.edit_btn || _E(), action: nf };
edit_switch.trig("visible", function (val) {
    if (!edit_switch.dom) return;
    if (val) {
        edit_switch.dom.remA("hidden").css("display:inline-block");
    } else {
        exception_flag.setA("inutil");
        edit_switch.dom.setA("hidden");
    }
});
edit_switch.trig(
    "active",
    function (val, old) {
        if (!!val === !!old) {
            // important  pt situatiile edit_switch.active=false --> confirm :fale --> stay active  --> LOOP
            return; // !!!BAC>>> ???
        }
        if (val) {
            // coming from inactive => start editing
            edit_switch.dom.setAttribute("edit_switch_active", "");
            edit_switch.action(val);
            session.enter_edit_mode(); // -- intra automat in edit_mode
        } else {
            edit_switch.dom.removeAttribute("edit_switch_active");
            edit_switch.action(val);
            session.exit_edit_mode();
        }
    },
    0
);

edit_switch.dom.on("click", function (ev) {
    if (this.hasA("disabled") && !history.now.repair && !BAC) {
        dn(
            "nu se pot face editari in starea de <h4  style='color:#ffa'>EXCEPTIE : " +
            TE.exception +
            "</h4>",
            "NOPE",
            2000
        );
        return;
    }
    edit_switch.active = !edit_switch.active;
});



// de aici reconfigurez butoane si chestii pt intrarea si iesirea din edit mode
// presupune o anumita structura de site --- !!!BAC>>> -- amestec de librarie cu implementare :((
edit_switch.action = function (active) {
    if (active) {
        edit_buttons.setA("on");
        nav_btn.toXY("0,@-100");
        tools_btn.toXY("0,@-100");
        all_menu_buttons.setA("active_editing");
        Blinder.setA("active_editing")
        user_btn.toXY("@1000,0");
        task_btn.css("display:none");
        exception_flag.setA("inutil");
    } else {
        edit_buttons.remA("on");
        nav_btn.toXY("0,0");
        tools_btn.toXY("0,0");
        all_menu_buttons.remA("active_editing");
        Blinder.remA("active_editing")
        user_btn.toXY("0,0");
        task_btn.css("display:inline-block");
        exception_flag.remA("inutil");
    }
    collapse_top_menu();
    task_panel_collapse();
};



// !!! BAC >>> refac colectia de hinturi din sessionStorage daca vin dupa reload fortat peste  session.changes=true
COLECTED_FKID_HINTS = (SS.COLECTED_FKID_HINTS || "{}").parsed;
MAP2_DICTIONARY = (SS.MAP2_DICTIONARY || "{}").parsed;



Object.defineProperty(session, "crul", { // Cascade Undo Redo Last 
    // sets cascading settings for the last stack segment  
    // ex: session.crul(null,1) -- when undo current segment do the same to previous segment
    // ( 1,0 | 1,1 | 1,1 | 0,1 )  4 cascaded session.stack segments
    value: function (redo, undo) {
        let stk = session.stack.last();
        if (redo) {
            stk.cascade_redo = 1
        } else {
            delete stk.cascade_redo;
        }
        if (undo) {
            stk.cascade_undo = 1
        }
        else {
            delete stk.cascade_undo;
        }
        return stk;
    }
});



async function check_fkid_delete_restricted_record(o, cursor) {

    //  daca am cascadare in xform si sterg parintele unor recorduri referrentiate
    //  console.log(o);

    if (!o.id || /^did/.test(o.id) || o.xform) { // n-am ce sa mai vreau remote
        return
    }
    var POST = { tb_name: o.path[0], record_id: o.id };
    if (o.xform) { // trebuie sa ma asigur ca elementul in sine si oricare descendent din subtree nu este restrictionat
        var xf = o.path[0], cascade = TE.conf.cascade;
        let structure = get_check_structure({}, xf, [o.id]);
        if (Object.keys(structure).length > 1) { // am descendenti stersi care trebuie verificati 
            POST = { structure }
        }
    }
    var FOUND;
    await ask("db\\read.is_fkid_delete_restricted_record", POST, (rsp, code, xhr) => {
        FOUND = xhr.header('fkid_conflicts', 1)
    }).then(r => {
        //        console.log(__ML__, "IN SESSION", o);
        if (+r > 0) {
            var panel = Q.i({
                tb_name: o.path[0],
                id: o.id
            }, { title: "RECORD DELETE RESTRICTION" });

            panel.content._(`
                <div style='padding: 1em 0;font-family:thin'>
                    <sad fll></sad>
                    <div>Exita referinta la acest record in alte tabele <br/>deci nu poate fi sters (doar modificat)</div>
                </div>
                </div><hr/>FOUND: <m lc>${FOUND.length}</m>`,
                FOUND.to_table());


            if (session.cursor == cursor) {
                // daca am acelasi cursor pos sa fac undo in siguranta --  dac nu asta e o sa dea in bot la save
                session.undo("drop");
            }
        }
    });
}

function get_check_structure(acm = {}, tb_name, ids = []) { // culeg tot ce e in client pt ca asta e natura x-form (nu ascunde descendenti cel putin in date -- poate cel mult pe dom )
    if (!acm.hasOwnProperty(tb_name)) {
        acm[tb_name] = ids;
    }
    let desc = TE.conf.pointer(["cascade", tb_name]) || [];
    desc.map(desc_name => {
        let ref_idx = TE.columns[desc_name].indexOf("ref_id");
        desc_ids = [];
        ids.map(id => {
            (TE.data[desc_name] || []).map(s => {
                if (s[ref_idx] == id) {
                    desc_ids.push(s[0]);
                }
            });
        });
        if (desc_ids.length) {
            get_check_structure(acm, desc_name, desc_ids)
        }
    });
    return acm;
}